module.exports = __webpack_public_path__ + "img/medal_vip3.f063bf9.png";